import api from "../../services/api";

const useUsers = () => {
	const findAll = async (params) => {
        const { data } = await api.get("/users", { params });
        console.log('DATA USUARIOS', data)
        return data;
    }

	return { findAll };
};

export default useUsers;
